const p={path:"/api/v1/apps/:app_id/cross-app/connections",method:"GET"};export{p as GetCrossAppConnections};
